<template>
    <div class="block-editor google-business-reply-review">
        <section>
            <div class="title">{{ $t('auto.googleBusinessReplyReviewChannelId') }}</div>
            <TiptapEditor placeholder="Google Business Channel ID" :show-attributes="true" v-model="clone.channelId" automation-mode />
            <small>{{ $t('auto.googleBusinessReplyReviewYanTVerilecekYorumunBulunduUKanalIdsi') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.googleBusinessReplyReviewReviewId') }}</div>
            <TiptapEditor placeholder="Google Business Review ID" :show-attributes="true" v-model="clone.reviewId" automation-mode />
            <small>{{ $t('auto.googleBusinessReplyReviewYanTVerilecekYorumunIdsi') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.googleBusinessReplyReviewYanTMetni') }}</div>
            <TiptapEditor placeholder="Yanıt metni giriniz..." :show-attributes="true" v-model="clone.text" automation-mode />
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "GoogleBusinessReplyReview",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                channelId: "",
                reviewId: "",
                text: "",
                ...this.value
            }),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.google-business-reply-review {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    small {
        color: #777;
    }
}
</style>
